import { Action, createReducer, on, createAction, props } from '@ngrx/store';

// Actions
export const login = createAction('[App] Login', props<{ subscriber: any }>());
export const logout = createAction('[App] Logout');

// Selectors
export const selectSubscriber = (state: AppState) => (state as any).app.subscriber;

export interface AppState {
  subscriber: any;
}

const initialState: AppState = {
  subscriber: null,
};

const appReducer = createReducer(
  initialState,
  on(login, (state, { subscriber }) => ({ ...state, subscriber })),
  on(logout, state => initialState),
);

export function AppReducer(state: AppState | undefined, action: Action): AppState {
  return appReducer(state, action);
}
